import React from 'react';
import { shape, number, func } from 'prop-types';
import DECheckbox from '../../../shared/DECheckbox';
import { numberWithCommas } from '../../../../../util/CommonUtils';
import DisabledIcon from '../../../shared/icons/DisabledIcon';

const DefinitionTableBodyRow = ({ item, onRowSelect }) => {
  return (
    <div
      className={`de--def--table__row ${
        item.isActive ? 'de--def--table__row--checked' : ''
      }`}
    >
      <div className="de--def--table__col de--def--col__select">
        <DECheckbox
          onChange={onRowSelect}
          id={`ct_select_${item.ui}`}
          isChecked={item.isActive}
          data={item}
          disabled={item.isDisabled}
        />
      </div>

      <div className="de--def--table__col de--def--col__name" title={item.tn}>
        <span
          className={`de--def--col__name__span ${
            item.isDisabled ? 'de--def--col__name__span--disabled' : ''
          }`}
        >
          {item.tn}
        </span>
        {item.isDisabled && (
          <span
            className ="de--def--col__icondisabled"
            title ="Definition not available in the current study.">
            <DisabledIcon/>
          </span>
        )}
      </div>

      <div
        className={`de--def--table__col de--def--col__sample
          ${item.ss < 1000 ? 'de--def--col__sample__threshold' : ''}`}
      >
        <span>
          {item.ss
            ? numberWithCommas(Math.round(item.ss))
            : item.ss}
        </span>
      </div>

      <div className="de--def--table__col de--def--col__wgth">
        <span>
          {item.weighted
            ? numberWithCommas(Math.round(item.weighted))
            : item.weighted}
        </span>
      </div>
    </div>
  );
};

DefinitionTableBodyRow.propTypes = {
  item: shape({
    sample: number,
    weighted: number,
  }),
  onRowSelect: func,
};

export default DefinitionTableBodyRow;
